// All icon instances are decorative by default (aria-hidden).
// Pass `label` only when the icon carries meaning that text nearby does NOT convey.
export default function Icon({ name, size = 20, style = {}, label }) {
  return (
    <span
      className="material-symbols-outlined"
      aria-hidden={label ? undefined : 'true'}
      role={label ? 'img' : undefined}
      aria-label={label}
      style={{ fontSize: size, lineHeight: 1, verticalAlign: 'middle', userSelect: 'none', ...style }}
    >
      {name}
    </span>
  );
}
